export default __webpack_public_path__ + "static/media/nandha_engineering.2c427232.jpg";